
import { useLocation, useNavigate } from 'react-router-dom';
import './Details.css';
import { useEffect, useRef, useState } from 'react';
import AWS from 'aws-sdk';
import { useCustomContext } from '../CustomComponents/CustomComponents';
import LogsDS from '../../DataServices/LogsDs';
import ReferralDS from '../../DataServices/ReferralDs';
import { insertLog } from '../Logs/InsertLog';

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});
const s3 = new AWS.S3();

export const ClientDetailsLogic = () => {
  const [editSection, setEditSection] = useState(null); // 'personal', 'address', 'vehicle', 'court'
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [client, setClient] = useState([]);
  const { showAlert, hud, stopHudRotation, showToast } = useCustomContext();
  const [zohoData, setZohoData] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const [showModal, setShowModal] = useState(false);
  
  const openFolder = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);

  };

  const referralID = client?.referralID;
  const folderName = client?.referralID;
  console.log(" Client notes", client?.notes)
  console.log("referralID", referralID)
  const [files, setFiles] = useState([]);
  const [showFilesTable, setShowFilesTable] = useState(false);
  const fileInputRef = useRef();
  const logslistDs = new LogsDS();
  const [showLogs, setShowLogs] = useState(false);
  const [logsList, setLogsList] = useState([]);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };


  const handleDragLeave = () => {
    setIsDragging(false);
  };


  // Remove the reset logic from here.
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    handleFileUpload(files);
  };



  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files);
    handleFileUpload(files);
  };
  const handleToggleLogs = async () => {
    if (!showLogs) {
      await fetchLogs();
    }
    setShowLogs(prev => !prev);
  };
  const handleToggleFiles = async () => {
    if (!showFilesTable) {
      await fetchFiles();
    }
    setShowFilesTable(prev => !prev);
  };
  const referral = new ReferralDS();
  const referral_id = state?.referral_id || localStorage.getItem('referral_id');

  const fetchByReferralData = async () => {
    hud('Please Wait...');
    try {
      const response = await referral.RM_Referral_By_ReferralID_Get({
        referralID: referral_id
      });

      let data = response.data.body;
      console.log("Raw response body:", data);

      // 🧠 If it's a string, parse it
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (err) {
          console.error("Failed to parse JSON string:", err);
          data = null;
        }
      }

      // ✅ Handle both array and single object cases
      if (Array.isArray(data) && data.length > 0) {
        setClient(data[0]); // take the first item
      } else if (typeof data === 'object' && data !== null) {
        setClient(data); // single object case
      } else {
        console.warn("Unexpected response format:", data);
        setClient(null);
      }

    } catch (error) {
      console.error('Error:', error);
      const errorMessage = error.response?.data?.message || error.message || 'An error occurred.';
      showAlert(errorMessage, [{ label: 'Ok', onClick: () => { }, color: 'var(--buttonColor)' }]);
    } finally {
      stopHudRotation();
    }
  };

  useEffect(() => {
    fetchByReferralData();
  }, [referral_id])

  const uploadFileToS3 = async (file, referralID) => {
    const s3 = new AWS.S3({
      accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
      secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
      region: process.env.REACT_APP_AWS_REGION,
    });

    const params = {
      Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
      Key: `${referralID}/${file.name}`, // Folder structure in S3
      Body: file,
      ContentType: file.type,
    };
    hud("Please Wait...");
    try {
      const result = await s3.upload(params).promise();
      console.log("✅ Uploaded:", result.Location);
      return result;
    } catch (error) {
      console.error("❌ Upload failed:", error);
      throw error;
    } finally {
      stopHudRotation(); // Stop custom loader
    }
  };

  const fetchReferralZohoData = async () => {
    hud('Please Wait...');
    try {
      const response = await referral.RM_Referral_Info_To_Zoho_SEND({ referralID: referral_id });
      let data = response.data;

      if (typeof data.body === 'string') {
        data.body = JSON.parse(data.body);
      }

      const { zohoAccounts, message, zohoAccountId } = data.body || {};
      const hasZohoAccounts = Array.isArray(zohoAccounts) && zohoAccounts.length > 0;

      if (data.statusCode === 202) {
        if (hasZohoAccounts) {
          // ✅ Referral already exists in Zoho
          setZohoData(zohoAccounts);
          openFolder();

          
        } else {
          // ✅ Referral was freshly uploaded
          setClient(prev => ({
            ...prev,
            isInfoUploadedToZoho: 1 // Successfully uploaded
          }));

          showToast({ message: message || 'Referral info successfully uploaded to Zoho Sharks.' });
          const clientName = `${client?.firstName || ''} ${client?.lastName || ''}`.trim();
          const logDescription = `${userName} uploaded ${clientName} referral info to Zoho Sharks (Zoho ID: ${zohoAccountId || 'N/A'})`;
          await insertLog(logDescription, referral_id, useremail, hud, stopHudRotation, showToast);
          await fetchByReferralData();

        }
      }
      else if (data.statusCode === 200)
      {
        // 🔄 Refresh screen
        showToast({ message: message || 'Referral info successfully uploaded to Zoho Sharks.' });
        const clientName = `${client?.firstName || ''} ${client?.lastName || ''}`.trim();
        const logDescription = `${userName} uploaded ${clientName} referral info to Zoho Sharks (Zoho ID: ${zohoAccountId || 'N/A'})`;
        await insertLog(logDescription, referral_id, useremail, hud, stopHudRotation, showToast);
        setClient(prev => ({
          ...prev,
          isInfoUploadedToZoho: 1 // Successfully uploaded
        }));
        await fetchByReferralData();

      }
       else {

        showAlert && showAlert("Failed to upload referral info to Zoho. Please try again.", [
          { label: 'Ok', onClick: () => { }, color: 'var(--buttonColor)' }
        ]);

      }
    } catch (err) {
      console.error(err);
      showAlert && showAlert(err.message || "Failed to fetch referral data.", [
        { label: 'Ok', onClick: () => { }, color: 'var(--buttonColor)' }
      ]);
    } finally {
      stopHudRotation();
    }
  };

  const handleCreateReferral = async () => {
    hud("Please wait...");

    try {
      const res = await referral.RM_Referral_To_Zoho_LINK({
        referralID: referral_id
      });

      let linkData = res?.data || {};
      const statusCode = linkData?.statusCode;

      // ✅ Parse response body safely
      if (typeof linkData.body === "string") {
        try {
          linkData.body = JSON.parse(linkData.body);
        } catch {
          linkData.body = {};
        }
      }

      const { message, zohoAccountId } = linkData.body || {};

      if (statusCode === 200) {
        // ✅ Success flow
        showToast({ message: message || "Referral created successfully in Zoho" });

        setClient(prev => ({
          ...prev,
          isInfoUploadedToZoho: 3 // success uploaded
        }));

        const clientName = `${client?.firstName || ""} ${client?.lastName || ""}`.trim();
        const logMsg = `${userName} created a new referral in Zoho for ${clientName} (Zoho ID: ${zohoAccountId || "N/A"})`;
        await insertLog(logMsg, useremail, hud, stopHudRotation, showToast);

        closeModal();
      } else {
      
        showAlert("Failed to upload referral info to Zoho. Please try again.", [
          { label: 'Ok', onClick: () => { }, color: 'var(--buttonColor)' }
        ]);
      }
    } catch (err) {
      console.error("Error creating referral:", err);

      showAlert(
        err?.message || "Failed to create referral in Zoho",
        [{ label: "Ok", onClick: () => { }, color: "var(--buttonColor)" }]
      );
      
    } finally {
      stopHudRotation?.();
    }
  };



  // Handle link to existing Zoho Shark
  const handleLinkToZoho = async (zohoAccountId) => {
    hud("Please wait...");
    try {
      const res = await referral.RM_Referral_To_Zoho_if_Exists_LINK({
        referralID: referral_id,
        isReferralLinkToZohoShark: true,
        zohoAccountId: zohoAccountId
      });

      let linkData = res.data;
      if (typeof linkData.body === 'string') {
        linkData.body = JSON.parse(linkData.body);
      }

      const { message, updatedStatus, zohoAccountId: responseZohoAccountId } = linkData.body || {};

      // ✅ Check if the response has the correct updated status and zohoAccountId
      if (updatedStatus === 2 && responseZohoAccountId === zohoAccountId) {
        // ✅ Set state to indicate link success
        setClient(prev => ({
          ...prev,
          isInfoUploadedToZoho: 2 // Set status to "linked"
        }));

        const clientName = `${client?.firstName || ''} ${client?.lastName || ''}`.trim();
        const logDescription = `${userName} linked referral (${clientName}) to existing Zoho Shark (Zoho ID: ${zohoAccountId})`;
        await insertLog(logDescription, referral_id, useremail, hud, stopHudRotation, showToast);

        // ✅ Close modal
        closeModal();

        // ✅ Show success message
        showToast({ message: message || "Referral linked to Zoho Shark successfully." });
      } else {
        // If the status or zohoAccountId doesn't match, show an error message
        showAlert("Unexpected response from Zoho. Please try again.", [
          { label: 'Ok', onClick: () => { }, color: 'var(--buttonColor)' }
        ]);
      }
    } catch (err) {
      console.error(err);

      // Show error alert instead of toast
      showAlert(err.message || "Failed to link referral to Zoho Shark.", [
        { label: 'Ok', onClick: () => { }, color: 'var(--buttonColor)' }
      ]);
    } finally {
      stopHudRotation && stopHudRotation();
    }
  };



  const fetchFiles = async () => {
    if (!folderName) return;

    hud("Please Wait..."); // Start custom loader
    try {
      const params = {
        Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
        Prefix: `${folderName}/`,
        Delimiter: '/', // Ensures only immediate children are returned
      };

      const data = await s3.listObjectsV2(params).promise();

      const fileNames = (data.Contents || [])
        .filter(item => item.Key !== `${folderName}/`) // Exclude the folder itself
        .map(item => item.Key.split('/').pop())        // Just get the file name

      setFiles(fileNames); // Now files contains just names
      console.log("Files in folder:", fileNames);
    } catch (err) {
      console.error('Error fetching files:', err);
      showAlert(err.message || 'Error fetching files', [
        { label: 'Ok', color: 'var(--buttonColor)', onClick: () => { } }
      ]);
    } finally {
      stopHudRotation(); // Stop custom loader
    }
  };

  const fetchLogs = async () => {
    hud('Please Wait...');
    try {
      const response = await logslistDs.RM_Activity_Logs_ByID_Get({
        referralID: referralID
      });
      let data = response.data.body;
      console.log("Raw response body:", data);

      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (err) {
          console.error("Failed to parse JSON string:", err);
          data = { logs: [] };
        }
      }
      if (Array.isArray(data.logs)) {
        const sortedLogs = data.logs.sort((a, b) => {
          const dateA = new Date(a.AddedTimeStamp);
          const dateB = new Date(b.AddedTimeStamp);
          return dateB - dateA;
        });

        setLogsList(sortedLogs);
        console.log("Sorted logs:", sortedLogs);
      } else {
        console.warn("Expected array in data.logs but got:", data);
        setLogsList([]);
      }

    } catch (error) {
      console.error('Error:', error);
      const errorMessage = error.response?.data?.message || error.message || 'An error occurred.';
      showAlert(errorMessage, [{ label: 'Ok', onClick: () => { }, color: 'var(--buttonColor)' }]);
    } finally {
      stopHudRotation();
    }
  };
  const useremail = localStorage.getItem("email");
  const userName = useremail?.split('@')[0];

  // useEffect(() => {
  //   fetchFiles();
  // }, [folderName, referralID]);


  // Refactor the handleFileUpload function
  const handleFileUpload = async (filesToUpload) => {
    if (!referralID || filesToUpload.length === 0) return;

    try {
      hud("Uploading...");

      const validFiles = filesToUpload.filter(file => {
        if (file.size > 10 * 1024 * 1024) { // 10MB limit
          showAlert(`File "${file.name}" is too large. Max 10MB allowed.`, [{
            label: 'Ok',
            onClick: () => { },
            color: 'var(--buttonColor)',
          }]);
          return false;
        }
        return true;
      });

      if (validFiles.length === 0) return;

      await Promise.all(validFiles.map(file => uploadFileToS3(file, referralID)));

      const fileNames = validFiles.map(file => file.name).join(", ");
      const logDescription = `${userName} uploaded the following files: ${fileNames}`;
      await insertLog(logDescription, referralID, useremail, hud, stopHudRotation, showAlert);

      fetchFiles();
      showToast({ message: "Files uploaded successfully." });
    } catch (error) {
      console.error("Upload error:", error);
      showAlert("File upload failed. Please try again.", [{
        label: 'Ok',
        onClick: () => { },
        color: 'var(--buttonColor)',
      }]);
    } finally {
      stopHudRotation();
      // ✅ The crucial fix: Reset the input field here using the ref.
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };
  const isPreviewable = (fileName) => {
    const ext = fileName.toLowerCase();
    return (
      ext.endsWith('.pdf') ||
      ext.endsWith('.jpg') ||
      ext.endsWith('.jpeg') ||
      ext.endsWith('.png') ||
      ext.endsWith('.gif') ||
      ext.endsWith('.webp') ||
      ext.endsWith('.svg')
    );
  };

  const handlePreview = async (file) => {
    const fileName = file;
    const key = `${folderName}/${fileName}`;

    const params = {
      Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
      Key: key,
    };

    try {
      if (!isPreviewable(fileName)) {
        showAlert("This file type cannot be ewed.", [
          { label: 'OK', color: 'var(--buttonColor)' }
        ]);
        return;
      }

      const signedUrl = s3.getSignedUrl('getObject', params);
      window.open(signedUrl, '_blank');

    } catch (error) {
      console.error("❌ Preview error:", error);
      showAlert("Preview failed: " + (error.message || ""), [
        { label: 'OK', color: 'var(--buttonColor)' }
      ]);
    }
  };


  const handleDownload = async (file) => {
    const fileName = file;
    const key = `${folderName}/${fileName}`;

    const params = {
      Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
      Key: key,
    };

    try {
      hud("Please Wait...");

      const signedUrl = s3.getSignedUrl('getObject', params); // Pre-signed URL
      const response = await fetch(signedUrl);
      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl); // Clean up

      // ✅ Log after successful download
      const clientName = `${client?.firstName || ''} ${client?.lastName || ''}`.trim();
      const logDescription = `${userName} downloaded the file "${fileName}" from ${clientName}'.`;
      await insertLog(logDescription, referralID, useremail, hud, stopHudRotation, showAlert);
      console.log("✅ Log inserted for file download");

    } catch (error) {
      console.error("❌ Download error:", error);
      showAlert("Download failed: " + (error.message || ""), [
        { label: 'OK', color: 'var(--buttonColor)' }
      ]);
    } finally {
      stopHudRotation();
    }
  };



  const handleDelete = async (file) => {
    const fileName = file;

    showAlert(`Are you sure you want to delete "${fileName}"?`, [
      {
        label: 'Yes',
        color: 'var(--buttonColor)',
        onClick: async () => {
          const key = `${folderName}/${fileName}`; // Construct full path for S3 delete

          const params = {
            Bucket: process.env.REACT_APP_S3_BUCKET_NAME,
            Key: key,
          };
          hud("Please Wait...");
          try {

            await s3.deleteObject(params).promise();
            console.log("✅ Deleted:", key);
            showToast({ message: `${fileName} deleted successfully.` });
            // Remove file from UI
            fetchFiles()
            const clientName = `${client?.firstName || ''} ${client?.lastName || ''}`.trim();
            await insertLog(`${userName} deleted file ${fileName} from this ${clientName}`, referralID, useremail, hud, stopHudRotation, showAlert);
          } catch (error) {
            console.error("❌ Delete failed:", error);
            showAlert("Delete failed: " + (error.message || ""), [
              { label: 'OK', color: 'var(--buttonColor)' }
            ]);
          } finally {
            stopHudRotation(); // Stop custom loader
          }
        }
      },
      {
        label: 'No',
        color: 'gray',
        onClick: () => { }
      }
    ]);
  };
  const handleStatusChange = async (newStatus) => {
    hud('Please Wait...');
    try {
      const response = await referral.RM_Referral_Status_Update({
        referralID: referralID,
        status: newStatus
      });

      let data = response.data.body;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (err) {
          console.error("Failed to parse JSON string:", err);
          data = {};
        }
      }

      if (data.message) {
        // ✅ Prepare the log description
        const clientName = `${client?.firstName || ''} ${client?.lastName || ''}`.trim();
        const logDescription = `${userName} opened ${clientName} and changed the status to ${newStatus}`;

        await insertLog(logDescription, referralID, useremail, hud, stopHudRotation, showAlert);
        fetchByReferralData();

        // ✅ Show toast instead of alert
        showToast({ message: data.message }); // 🔄 Toast here
        console.log("Message:", data.message);
      } else {
        console.warn("Expected a message in response but got:", data);
      }

    } catch (error) {
      console.error('Error:', error);
      const errorMessage = error.response?.data?.message || error.message || 'An error occurred.';
      showToast({ message: errorMessage }); // 🔄 Toast on error
    } finally {
      stopHudRotation();
    }
  };



  const accessLevel = parseInt(localStorage.getItem('accessLevel'), 10);
  if (!client) {
    return <p className="error">Client data not found</p>;
  }

  return {
    editSection, setEditSection, isModalOpen, setIsModalOpen, client,
    isDragging, navigate, files,
    fileInputRef, logsList, showLogs, fetchByReferralData, handleToggleLogs,
    handleFileChange, handleDragOver, handleDragLeave, handleDrop,
    handlePreview, handleDownload, handleDelete, handleStatusChange,
    accessLevel, isPreviewable, handleToggleFiles, showFilesTable, fetchReferralZohoData, openFolder, closeModal, showModal, zohoData
    , handleCreateReferral, handleLinkToZoho
  };
};
